import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'telus-table-options',
  templateUrl: 'table-options.html',
  styleUrls: ['./table-options.scss'],
})
export class TelusTableOptionsComponent {
  @Input() labelText = '';
  @Input() showToggle = false;

  @Output() editColumns = new EventEmitter();
  @Output() toogle = new EventEmitter<boolean>();

  active = true;

  constructor() {}

  onEditColumns() {
    this.editColumns.emit();
  }

  onToggle(e: Event) {
    e.stopPropagation();

    this.toogle.emit(!this.active);
  }
}
